import { render, staticRenderFns } from "./topickeyword copy.vue?vue&type=template&id=1b9eb2a6&scoped=true"
import script from "./topickeyword copy.vue?vue&type=script&lang=js"
export * from "./topickeyword copy.vue?vue&type=script&lang=js"
import style0 from "./topickeyword copy.vue?vue&type=style&index=0&id=1b9eb2a6&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1b9eb2a6",
  null
  
)

export default component.exports